export default "__VITE_ASSET__C6xxfmxu__"